export default class MarkerType {
    id = null;
    label = null;
    description = null;
    normalizedLabel = null;
    isActive = true;
    isOrganizationSpecific = false;
    color = null;
    shape = null;
    eTag = null;

    constructor(type) {
        this.id = type.id;
        this.label = type.label;
        this.description = type.description;
        this.isActive = type.isActive;
        this.isOrganizationSpecific = type.isOrganizationSpecific;
        this.normalizedLabel = type.normalizedLabel;
        this.color = type.color;
        this.shape = type.shape;
        this.eTag = type.eTag;
    }
}